import React, { FC } from 'react';
import { StockModelCardDealerInfoProps } from '.';
import useTranslations from '@hooks/useTranslations';
import Icon, { Icons } from '../../../Icon';
import getRelativeAvailabilityTime from '../../utils/getRelativeAvailabilityDate';
import { useSelector } from 'react-redux';
import { Redux } from 'src/redux/redux.interface';
import FilterDuck from '../../../../redux/filters/filter.duck';
import { DealerLocation } from './StockModelCardDealerInfoStyled';
import { useRouter } from 'next/router';
import routes from '../../../../constants/routes';
import { useFeatureSwitchEnabled } from '@hooks/useFeatureSwitchEnabled';
import { FEATURES_LIST } from '../../../../context/featureSwitchApp';
import { isBrandAC } from '../../../../constants/main';
import Button from "@components/Button";

export const StockModelCardDealerInfoTemplate: FC<StockModelCardDealerInfoProps> = ({
    className,
    handleRedirect,
    availabilityDate,
    dealerName,
    dealerLocationHeight,
    dealerCity,
    dealerDistance,
    isSubmitting,
}) => {
    const { t } = useTranslations();
    const router = useRouter();

    const isLocalizationEnabled = useFeatureSwitchEnabled(FEATURES_LIST.FEATURE_SWITCH_FORCE_LOCALIZATION_ENABLED);

    const geoLocation = useSelector((state: Redux) => FilterDuck.getGeoLocation(state));

    const showDealer =
        dealerName &&
        (!isLocalizationEnabled ||
            router.pathname.includes(routes.SELECTOR) ||
            (isLocalizationEnabled && router.pathname.includes(routes.CAR) && geoLocation));

    return (
        <div className={`${className} stockModelCard-dealerInfo`}>
            <div className="stockModelCard-dealerInfo--ctaSection">
                <Button disabled={isSubmitting} onClick={handleRedirect} primary fullWidth>
                    {t('stockModelCard.seeDetails')}
                </Button>
            </div>

            <DealerLocation>
                {availabilityDate && (
                    <div className="date">
                        <Icon name={Icons.Clock} height={16} width={16} className="date-icon" />
                        {getRelativeAvailabilityTime(availabilityDate)}
                    </div>
                )}
                {showDealer && (
                    <div className="dealer-location" style={{ height: dealerLocationHeight }}>
                        <Icon
                            name={isBrandAC ? Icons.MapPointTypeTwo : Icons.MapPoint}
                            height={25}
                            width={25}
                            altId={t('DealerLocation.heading')}
                            altText={t('DealerLocation.heading')}
                            className="dealer-location--icon"
                        />
                        <div className="dealer-location--info">
                            {dealerDistance && geoLocation && (
                                <span className="dealer-location--distance">
                                    {t('stockModelCard.distance', {
                                        city: dealerCity,
                                        distance: dealerDistance.toFixed(0),
                                    })}
                                </span>
                            )}
                            <span className="dealer-location--address">{dealerName}</span>
                        </div>
                    </div>
                )}
            </DealerLocation>
        </div>
    );
};

export default StockModelCardDealerInfoTemplate;
